import { useEffect } from 'react'
import { ChatChannelInstance } from '../types'
import { markMessageDeleted } from '../stores'

export type UseDeletedMessageIdsSyncOptions = {
  channel: ChatChannelInstance | null
}

// @spec FR-0077/AC-7@v1 — subscribe to Stream's `message.deleted` events.
export function useDeletedMessageIdsSync({ channel }: UseDeletedMessageIdsSyncOptions) {
  useEffect(() => {
    if (!channel) return

    const handleMessageDeleted = (event: any) => {
      const id = event?.message?.id
      if (id) markMessageDeleted(id)
    }

    channel.on('message.deleted', handleMessageDeleted)
    return () => {
      channel.off('message.deleted', handleMessageDeleted)
    }
  }, [channel])
}
